// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-malawi/calculator-malawi-personal-loan/calculator-malawi-personal-loan.component.scss
// module id = 735
// module chunks = 0